import React from 'react';
import styled from "styled-components";
import Avatar from './Avatar';
import BoldText from './BoldText';
import NormalText from './NormalText';
import { media } from '../styles/Mixin'





const ReCommentBox = ({
    key,
    reProfileImage,
    reAuthorName,
    reCommentText,
}) =>{

    return(
        <ReCommentInfoBox key={key}>
            <ReLeftInfo>
                <ReAvatarBox>
                    <Avatar
                        url={reProfileImage}
                        size={"m_md"}
                    />
                    {/* <Avatar url={"https://yt3.ggpht.com/a-/AOh14GiX4zNJW-Rxu5OiUYFVXTSKcvFcBLqYmf6eU6l4=s100-c-k-c0xffffffff-no-rj-mo"} size={"m_md"} /> */}
                </ReAvatarBox>
            </ReLeftInfo>
            <ReRightInfo>
                <Row>
                    <ReAuthorDisplayNameBox>
                        <BoldText text={reAuthorName} />
                        {/* <BoldText text={"parkminh5"} /> */}
                    </ReAuthorDisplayNameBox>
                </Row>
                <ReTextBox>
                    <NormalText text={reCommentText} />
                    {/* <CustomNormalText text={"안녕하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는하세요 저는"} /> */}
                </ReTextBox>
            </ReRightInfo>
        </ReCommentInfoBox>
    )
}


export default ReCommentBox

const Row = styled.div`
    width:100%;
    display:flex;
    flex-direction:row;
`

const ReCommentInfoBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    width:100%;
    margin-top:13px;
    margin-bottom:13px;
`

const ReLeftInfo = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
`

const ReRightInfo = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
`

const ReAvatarBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    ${media.deskTop`
    margin-right:10px;
    `}
    ${media.mobile`
    margin-right:5px;
    `}
    
`

const ReAuthorDisplayNameBox = styled.div`
    display:flex;
    flex-direction:row;
    margin-right:10px;
`
const ReTextBox = styled.div`
`